// If you are using Next.js 13+ with the app directory, you can also add the
// "use client" directive instead of (or in addition to) the import below.
// "use client";

import React from "react";

export default function AdHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b55141257507eddf539e53100fb1f413.jpg"
          alt="Downtown Roseville California local businesses"
          title="Advertise your business in Roseville CA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-gray-900/40"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
              <i className="ri-megaphone-line text-white text-lg"></i>
            </div>
            <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider">
              Business Advertising
            </span>
          </div>

          <h1 className="text-5xl font-bold text-white mb-5 leading-tight">
            Reach Thousands of <span className="text-amber-400">Roseville</span> Residents
          </h1>

          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Promote your local business on Roseville.org — the city&apos;s most trusted
            community platform. Connect with residents, visitors, and new families moving
            to the area.
          </p>
        </div>
      </div>
    </section>
  );
}
